import { IPanelProps, Panel } from '@fluentui/react/lib/Panel';
import { Stack } from '@fluentui/react/lib/Stack';
import React from 'react';
import { defineMessages } from 'react-intl';
import { LuisText } from 'src/core/components/LuisText';
import { useLocalization } from 'src/core/hooks/useLocalization';
import { QnaMakerContextColumnRenderer } from 'src/qnaMaker/appShell/qnaMakerEditPage/components/QnaMakerContextColumnRenderer';
import { QnaMakerContextTreeNode } from 'src/qnaMaker/core/types/QnaMakerContextTreeNode';

const messages = defineMessages({
    close: { id: 'qnaMaker.qnaMakerQnaPairContextPanel.close', defaultMessage: 'Close' },
    contextTree: { id: 'qnaMaker.qnaMakerQnaPairContextPanel.contextTree', defaultMessage: 'Context tree' },
    description: {
        id: 'qnaMaker.qnaMakerQnaPairContextPanel.description',
        defaultMessage:
            'The context tree shows the connections between a question answer pair and any other question answer pair. Connections are made with follow up prompts.'
    }
});

export type QnaMakerQnaPairContextPanelProps = IPanelProps & {
    qnaId: number;
    isOpen: boolean;
    onDismiss: () => void;
    isContextOnly: boolean;
    isContextTreeCalculating: boolean;
    handleQnaContextualNavigation: (id: number) => void;
    contextTreeMap: Map<number, QnaMakerContextTreeNode[]>;
};

export const QnaMakerQnaPairContextPanel = (props: QnaMakerQnaPairContextPanelProps) => {
    const { localize } = useLocalization();
    const {
        qnaId,
        onDismiss,
        isContextOnly,
        contextTreeMap,
        isOpen = false,
        isContextTreeCalculating,
        handleQnaContextualNavigation
    } = props;

    return (
        <Panel
            isLightDismiss
            isOpen={isOpen}
            onDismiss={onDismiss}
            headerText={localize(messages.contextTree)}
            closeButtonAriaLabel={localize(messages.close)}>
            <Stack tokens={{ childrenGap: 15 }}>
                <LuisText>{localize(messages.description)}</LuisText>
                <LuisText fontWeight={600} size="14px">
                    {localize(messages.contextTree)}
                </LuisText>
                <QnaMakerContextColumnRenderer
                    qnaId={qnaId}
                    isContextTreeCalculating={isContextTreeCalculating}
                    isContextOnly={isContextOnly}
                    contextTrees={contextTreeMap.get(qnaId) || []}
                    onClickQna={handleQnaContextualNavigation}
                />
            </Stack>
        </Panel>
    );
};
